//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.fragment.selections

import blazern.lexisoup.graphql.model.type.GraphQLInt
import blazern.lexisoup.graphql.model.type.GraphQLString
import blazern.lexisoup.graphql.model.type.Sentence
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CompiledFragment
import com.apollographql.apollo.api.CompiledSelection
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.notNull
import kotlin.collections.List

public object TranslationsSetFieldsSelections {
  private val __original: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "__typename",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledFragment.Builder(
          typeCondition = "Sentence",
          possibleTypesSet = setOf("Sentence")
        ).selections(SentenceFieldsSelections.__root)
        .build()
      )

  private val __translations: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "__typename",
          type = GraphQLString.type.notNull()
        ).build(),
        CompiledFragment.Builder(
          typeCondition = "Sentence",
          possibleTypesSet = setOf("Sentence")
        ).selections(SentenceFieldsSelections.__root)
        .build()
      )

  public val __root: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "original",
          type = Sentence.type.notNull()
        ).selections(__original)
        .build(),
        CompiledField.Builder(
          name = "translations",
          type = Sentence.type.notNull().list().notNull()
        ).selections(__translations)
        .build(),
        CompiledField.Builder(
          name = "translationsQualities",
          type = GraphQLInt.type.notNull().list()
        ).build()
      )
}
